import 'css-chunksrc/client/pages/workloadPage/toolbar/sortDropdown/styles.scss';export default {
  "sortDropdown": "_sortDropdown_604bs_1",
  "title": "_title_604bs_10",
  "root": "_root_604bs_16",
  "input": "_input_604bs_20",
  "opened": "_opened_604bs_36",
  "icon": "_icon_604bs_41",
  "listRoot": "_listRoot_604bs_53",
  "list": "_list_604bs_53",
  "option": "_option_604bs_69",
  "selected": "_selected_604bs_75"
};